// eslint-disable-next-line
export default function objectToQueryString(obj: any) {
  const keys = Object.keys(obj);
  const keyValuePairs = keys.map((key) => {
    if (obj[key] === undefined || obj[key] === null) return '';
    return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
  });
  return keyValuePairs.filter((x) => x !== '').join('&');
}
